<template>
    <path
        d="M12 20v-7m0 7c2.942 0 5.46-1.945 6.496-4.7M12 20c-2.942 0-5.46-1.945-6.496-4.7M14.829 7A3 3 0 1 0 9.17 7m5.66 0h1.93c.472.47.885 1.01 1.222 1.604M14.83 7H9.171m0 0H7.24a7.455 7.455 0 0 0-1.223 1.604M21 3v2.54a3 3 0 0 1-2.412 2.942l-.606.122M3 3v2.54a3 3 0 0 0 2.412 2.942l.606.122M22 21v-2.54a3 3 0 0 0-2.412-2.942l-1.092-.219M2 21v-2.54a3 3 0 0 1 2.412-2.942l1.092-.219m12.992 0A7.95 7.95 0 0 0 19 12.5a7.87 7.87 0 0 0-1.018-3.896M5.504 15.299A7.948 7.948 0 0 1 5 12.5c0-1.427.372-2.76 1.018-3.896"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
    />
</template>

<script>
import IconSvgBase from "./IconSvgBase";

export default {
    extends: IconSvgBase,
    name: "IconThreat",
};
</script>
